import React from 'react';
import { IProps as IBlockProps } from './QuickExitBlock.interface';
import QuickExitBlock from './QuickExitBlock.component';
import TranslationComponent from '@/utils/TranslationComponent/TranslationComponent';

export interface IBlockInputProps {
    heading: string;
    message: string;
    closeCtaLabel: string;
    exitUrl: string;
    [key: string]: any;
}

const mapInputToProps = (input: IBlockInputProps): IBlockProps => {
    const {
        heading, headingMobile, message, closeCtaLabel, exitUrl,
        ...rest
    } = input;

    return {
        title: heading,
        titleMobile: headingMobile,
        closeButtonLabel: closeCtaLabel,
        redirectUrl: exitUrl,
        ...rest,
    };
};

const BlockTranslation: React.FC<IBlockInputProps> = (inputProps) => {
    return (
        <TranslationComponent
            inputProps={inputProps}
            TargetComponent={QuickExitBlock}
            mapProps={mapInputToProps}
        />
    );
};

export default BlockTranslation;
